module.exports = __webpack_public_path__ + "static/media/job_category_23.faaf6e58.png";